import React, { SVGProps } from 'react';

const ExploreRealEstateIcon = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="100%"
			height="100%"
			viewBox="0 0 21 21"
			fill="none"
			{...props}
		>
			<path
				d="M16.5837 14.5827C16.917 13.9993 17.167 13.3327 17.167 12.5827C17.167 10.4993 15.5003 8.83268 13.417 8.83268C11.3337 8.83268 9.66699 10.4993 9.66699 12.5827C9.66699 14.666 11.3337 16.3327 13.417 16.3327C14.167 16.3327 14.8337 16.0827 15.417 15.7493L18.0837 18.416L19.2503 17.2493L16.5837 14.5827ZM13.417 14.666C12.2503 14.666 11.3337 13.7493 11.3337 12.5827C11.3337 11.416 12.2503 10.4993 13.417 10.4993C14.5837 10.4993 15.5003 11.416 15.5003 12.5827C15.5003 13.7493 14.5837 14.666 13.417 14.666ZM10.5003 17.166V18.8327C5.90033 18.8327 2.16699 15.0993 2.16699 10.4993C2.16699 5.89935 5.90033 2.16602 10.5003 2.16602C14.5337 2.16602 17.892 5.03268 18.667 8.83268H16.942C16.6821 7.82588 16.1903 6.89383 15.5059 6.11103C14.8214 5.32822 13.9634 4.71636 13.0003 4.32435V4.66602C13.0003 5.58268 12.2503 6.33268 11.3337 6.33268H9.66699V7.99935C9.66699 8.45768 9.29199 8.83268 8.83366 8.83268H7.16699V10.4993H8.83366V12.9993H8.00033L4.00866 9.00768C3.90033 9.49102 3.83366 9.98268 3.83366 10.4993C3.83366 14.1743 6.82533 17.166 10.5003 17.166Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default ExploreRealEstateIcon;
